export const formatToBRLDate = (val: string) => {
 let v = val.replace(/\D/g, "");
 if (v.length > 8) v = v.slice(0, 8);
 if (v.length >= 5) {
 return `${v.slice(0, 2)}/${v.slice(2, 4)}/${v.slice(4)}`;
 } else if (v.length >= 3) {
 return `${v.slice(0, 2)}/${v.slice(2)}`;
 }
 return v;
};

export const parseBRLDateToDB = (val: string) => {
 if (val.length === 10) {
 const [day, month, year] = val.split("/");
 return `${year}-${month}-${day}`;
 }
 return val;
};

export const loadDBDateToBRL = (val: string) => {
 if (!val) return "";
 if (val.includes("-")) {
 const [year, month, day] = val.split("-");
 return `${day}/${month}/${year}`;
 }
 return val;
};
